module.exports = __webpack_public_path__ + "static/img/nodata.2b09ec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Classify/nodata.png
// module id = 487
// module chunks = 0